import { omit } from "lodash";
import { emptySplitApi } from "./empty-split-api";
import {
  DeleteScheduleInput,
  Schedule,
  ScheduleInstanceInput,
  ScheduleSearchFilter,
} from "./types/schedules.type";

const SEARCH_SCHEDULES_DEFAULT_QUERY =
  "{id,title,is_available,recurrence_period,recurrence_day,recurrence_week,start_time,end_time,start_date,end_date,staff_member{id,title,full_name,name,first_name,photo,last_name,suffix,default_clinic},clinic,is_global_practice_event,notes,type,created_by,created_at,updated_by,updated_at}";

export const schedulesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSchedules: builder.query<Schedule[], ScheduleSearchFilter>({
      query: ({ search, ordering, limit }) =>
        `/schedules/?search=${search}&limit=${limit}&ordering=${ordering}&query=${SEARCH_SCHEDULES_DEFAULT_QUERY}`,
      providesTags: (result) =>
        result?.map((schedule) => ({
          type: "Schedule" as const,
          id: schedule?.id,
        })) || [],
    }),
    addSchedule: builder.mutation<
      Schedule,
      Partial<Schedule> & ScheduleInstanceInput
    >({
      query: (data) => ({
        url: "/schedules/",
        method: "POST",
        body: omit(data, "type", "id"),
      }),
      invalidatesTags: ["Schedule", "StaffAvailability"],
    }),
    updateSchedule: builder.mutation<
      Schedule,
      Partial<Schedule> & ScheduleInstanceInput
    >({
      query: (data) => ({
        url: `/schedules/${data.modelId || data.id}/`,
        method: "PATCH",
        body: omit(data, "type", "id", "modelId"),
      }),
      invalidatesTags: ["Schedule", "StaffAvailability"],
    }),
    deleteSchedule: builder.mutation<string, DeleteScheduleInput>({
      query: ({ scheduleId, instance_start_date, instance_end_date }) => ({
        url: `/schedules/${scheduleId}/`,
        method: "DELETE",
        body: { instance_start_date, instance_end_date },
      }),
      invalidatesTags: ["Schedule", "StaffAvailability"],
    }),
  }),
});

export const {
  useGetSchedulesQuery,
  useDeleteScheduleMutation,
  useAddScheduleMutation,
  useUpdateScheduleMutation,
} = schedulesApi;
